var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ElementScaler",class:{},style:({})},_vm._l((_vm.elements),function(el,i){return _c('div',{staticClass:"slot",style:({'transform': 'scale('+_vm.calcScale()+')'})},[_vm._t(el)],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }